import React, { useState, createContext } from "react";
import moment from "moment";

export const ChartDataContext = createContext();

export const ChartDataProvider = props => {
  const [selectedDataPoint, setSelectedDataPoint] = useState(false);

  const [queriedData, setQueriedData] = useState({
    batched: null,
    spotter: null
  });

  const [selectedData, setSelectedData] = useState({
    selectedIndex: 0,
    selectedGraph: "wave",
    selectedSpotter: null
  });

  const [selectedOverlayData, setSelectedOverlayData] = useState({
    selectedDataSource: {
      id: 19,
      name: "Sofar Operational Wave Analysis",
      organization: "Sofar"
    },
    selectedDirectionalVariableId: 7,
    selectedMagnitudeVariableId: 20,
    selectedVariable: {
      id: 20,
      name: "Significant_wave_height_of_combined_wind_waves_and_swell"
    },
    selectedColorScale: [
      { pixelValue: 15.0, red: 124, green: 1, blue: 1, alpha: 200 },
      { pixelValue: 12.5, red: 239, green: 0, blue: 0, alpha: 200 },
      { pixelValue: 10.5, red: 255, green: 80, blue: 0, alpha: 200 },
      { pixelValue: 8.0, red: 255, green: 255, blue: 0, alpha: 200 },
      { pixelValue: 6.0, red: 128, green: 255, blue: 128, alpha: 200 },
      { pixelValue: 5.0, red: 16, green: 255, blue: 239, alpha: 200 },
      { pixelValue: 3.0, red: 0, green: 159, blue: 255, alpha: 200 },
      { pixelValue: 2.0, red: 0, green: 30, blue: 255, alpha: 200 },
      { pixelValue: 0.0, red: 0, green: 0, blue: 143, alpha: 200 }
    ],
    numberOfPointsOnSide: 90,
    numberOfPointsInPath: 5,
    timeIncrementMinutes: 750
  });

  const [trailTimestamp, setTrailTimestamp] = useState(moment());

  return (
    <ChartDataContext.Provider
      value={{
        queriedData,
        selectedData,
        selectedDataPoint,
        selectedOverlayData,
        trailTimestamp,
        setQueriedData,
        setSelectedData,
        setSelectedDataPoint,
        setSelectedOverlayData,
        setTrailTimestamp
      }}
    >
      {props.children}
    </ChartDataContext.Provider>
  );
};
